import { jsx, jsxs } from "react/jsx-runtime";
import { Modal, Icon, ModalHeader } from "@flatfile/design-system";
import { named } from "../../../utils/named.js";
import { AlertContentWrapper, AlertIconWrapper, ModalText } from "../Styles.js";
import styled from "styled-components";
const Underline = styled.span`
  border-bottom: ${({ theme }) => `1px dotted ${theme.modal.underline}`};
  display: inline-flex;
`;
const AlertModalContent = (props) => {
  return /* @__PURE__ */ jsxs(AlertContentWrapper, { "data-testid": props["data-testid"], children: [
    /* @__PURE__ */ jsx(AlertIconWrapper, { children: /* @__PURE__ */ jsx(Icon, { name: "alertTriangle", size: 24 }) }),
    /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx(ModalHeader, { children: props.text.heading }),
      /* @__PURE__ */ jsx(ModalText, { children: props.text.description }),
      props.children
    ] })
  ] });
};
const AlertModal = (props) => {
  const content = AlertModalContent(props);
  return /* @__PURE__ */ jsx(Modal, { content });
};
named("AlertModal", AlertModal);
export {
  Underline,
  AlertModal as default
};
